import * as actionTypes from "../actionTypes";
import axios from "axios";
import {
  config,
  FETCH_SKU_CONFIG,
  FETCH_PRODUCTS_CONFIG,
} from "../../../config/config";

const fetchProductsStart = () => {
  return {
    type: actionTypes.FETCH_PRODUCTS_START,
  };
};

const fetchProductsSuccess = (products) => {
  return {
    products,
    type: actionTypes.FETCH_PRODUCTS_SUCCESS,
  };
};

const fetchProductsFailed = (fetchError) => {
  return {
    fetchError,
    type: actionTypes.FETCH_PRODUCTS_FAILED,
  };
};

export const onFetchProducts = () => {
  return async (dispatch) => {
    await dispatch(fetchProductsStart());
    try {
      const products = await axios.get(
        `${config.products}?page=${FETCH_PRODUCTS_CONFIG.page}&limit=${FETCH_PRODUCTS_CONFIG.limit}&disabled=${FETCH_PRODUCTS_CONFIG.disabled}`
      );
      await dispatch(fetchProductsSuccess(products.data));
    } catch (err) {
      await dispatch(fetchProductsFailed());
    }
  };
};

// SKU
const fetchSkuStart = () => {
  return {
    type: actionTypes.FETCH_SKU_START,
  };
};

const fetchSkuSuccess = (sku) => {
  return {
    sku,
    type: actionTypes.FETCH_SKU_SUCCESS,
  };
};

const fetchSkuFailed = (err) => {
  return {
    err,
    type: actionTypes.FETCH_SKU_FAILED,
  };
};

export const onFetchSku = () => {
  return async (dispatch) => {
    await dispatch(fetchSkuStart());
    try {
      const sku = await axios.get(
        `${config.skus}?page=${FETCH_SKU_CONFIG.page}&limit=${FETCH_SKU_CONFIG.limit}&disabled=${FETCH_SKU_CONFIG.disabled}`
      );
      await dispatch(fetchSkuSuccess(sku.data));
    } catch (err) {
      console.error(err, err.response, "FETCH_SKU_ERROR");
      await dispatch(fetchSkuFailed());
    }
  };
};
